var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":"https://docs.google.com/presentation/d/1poiNHc8GZsChJOKH15dbjZtoLHENYSs-WZVqdK-IRVY/embed?start=false&loop=false&delayms=3000","frameborder":"0","width":"100%","height":"100%","allowfullscreen":"true","mozallowfullscreen":"true","webkitallowfullscreen":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }